import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import { Button, ButtonGroup } from '@superops/ui-design-system';

/**
 * Year selector
 * @component
 */

const YearSelector = ({ yearsList = [], onSelect, selected }) => {
  return (
    <ButtonGroup segmented>
      {yearsList.map((item, index) => {
        if (item && item.name)
          return (
            <Button
              outline={!(selected === item.name)}
              key={index + 'year'}
              id={item.name}
              onClick={() => onSelect(item)}
              primary={selected === item.name}
              iconColor={selected === item.name ? 'black' : '#212b36'}
              icon={<SVGIcon name="DatePicker" />}
            >
              <span>{item.name}</span>
            </Button>
          );
      })}
    </ButtonGroup>
  );
};

export default YearSelector;
